module.exports = __webpack_public_path__ + "img/banner01.9ce45238.webp";